import React from 'react';
import { TableBody, TableRow, TableCell, Checkbox, IconButton } from '@mui/material';
import moment from 'moment';
import EditIcon from '@mui/icons-material/Edit';
import DocumentScannerIcon from '@mui/icons-material/DocumentScanner';
import PaidIcon from '@mui/icons-material/Paid';
import { ParcelRow } from '../types'; // Assuming types are defined here

interface TableRowsProps {
  rows: ParcelRow[];
  checkbox: Record<string, boolean>;
  handleCheckBox: (event: React.ChangeEvent<HTMLInputElement>) => void;
}

const TableRows: React.FC<TableRowsProps> = ({ rows, checkbox, handleCheckBox }) => {
  return (
    <TableBody>
      {rows.map((row) => (
        <TableRow key={row.id}>
          <TableCell align="left">
            <Checkbox
              name={`checkbox-${row.id}`}
              checked={checkbox[`checkbox-${row.id}`] ?? false}
              onChange={handleCheckBox}
            />
          </TableCell>
          <TableCell>{moment(row.booking_date).tz('Asia/Dhaka').format('DD/MMM/YY hh:mma')}</TableCell>
          <TableCell align="left">
            {row.id}
            {row.memoNo ? (
              <>
                <hr />
                <div className="text-nowrap">Invoice: {row.memoNo}</div>
              </>
            ) : null}
          </TableCell>
          <TableCell align="left">
            <div className="md:text-xs">
              Name: {row.customerName} <br />
              Area: {row.area?.name} <br />
              Phone: {row?.phoneNumber} <br />
              Weight: {row.weight}
            </div>
          </TableCell>
          <TableCell align="left">
            <div className="md:text-xs">
              <div className="text-nowrap">Cash Collection: {row.COD}</div>
              <div className="text-nowrap">Charge: {row.deliveryCharge}</div>
            </div>
          </TableCell>
          <TableCell align="left">
            <div>{row.status}</div>
            {row.rider?.name ? <div>Rider: {row.rider?.name}</div> : null}
          </TableCell>
          <TableCell align="center">
            <div className="flex flex-nowrap">
              {row.status === 'BOOKING' ? (
                <div className="print:hidden text-nowrap">
                  <IconButton color="success" onClick={() => window.open(`/dashboard/parcel/edit/${row.id}`)}>
                    <EditIcon />
                  </IconButton>
                </div>
              ) : (
                <div>
                  <IconButton color="success" onClick={() => window.open(`/dashboard/parcel/view/${row.id}`)}>
                    <DocumentScannerIcon />
                  </IconButton>
                </div>
              )}
              <div>
                <IconButton
                  color="secondary"
                  disabled={!row?.payment?.id}
                  onClick={() =>
                    window.open(`/dashboard/paymentshow/${row?.payment?.id}?focusID=${row.id}#parcel-${row.id}`)
                  }
                >
                  <PaidIcon />
                </IconButton>
              </div>
            </div>
          </TableCell>
        </TableRow>
      ))}
    </TableBody>
  );
};

export default TableRows;
